import { render, staticRenderFns } from "./Alibaba-keywords-track.vue?vue&type=template&id=b21cb50a&scoped=true&"
import script from "./Alibaba-keywords-track.vue?vue&type=script&lang=js&"
export * from "./Alibaba-keywords-track.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-keywords-track.vue?vue&type=style&index=0&id=b21cb50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21cb50a",
  null
  
)

export default component.exports